import { render } from "./PaymentBlock.vue?vue&type=template&id=5a33cbb4&scoped=true"
import script from "./PaymentBlock.vue?vue&type=script&lang=js"
export * from "./PaymentBlock.vue?vue&type=script&lang=js"

import "./PaymentBlock.vue?vue&type=style&index=0&id=5a33cbb4&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\areaclienti.luceegasitalia.it\\areaclienti\\areaclienti\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a33cbb4"]])

export default __exports__